import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { IAppConfig } from './app-config.model';
@Injectable()
export class AppConfig {
    static settings: IAppConfig;
    constructor(private http: HttpClient) {}
    // load() {
    //     // const jsonFile = `assets/config/config.${environment.name}.json`;
    //     const jsonFile = `assets/config/config.dev.json`;
    //     return new Promise<void>((resolve, reject) => {
    //         this.http.get(jsonFile).toPromise().then((response : IAppConfig) => {
    //            AppConfig.settings = <IAppConfig>response;
    //            resolve();
    //         }).catch((response: any) => {
    //            reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
    //         });
    //     });
    // }
    load() {
        const jsonFile = 'assets/config/config.dev.json';
        return new Promise((resolve, reject) => {
            var response = this.GetSync(jsonFile);
            if (response && response != null) {
                AppConfig.settings = JSON.parse(response);
                resolve(true);
            }
            else
                reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
    }
        
    public GetSync(url: string): any {
        const xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, false);
        xmlhttp.overrideMimeType('application/json');
        
        xmlhttp.send();
        if (xmlhttp.status == 200) {
          return xmlhttp.responseText;
        }
        else {
          return null;
        }
    }
}